import cx from 'classnames';
import { format, isAfter, isBefore, isSameDay, parse } from 'date-fns';
import React from 'react';
import { getDay } from '../helpers';
import Day from './Day';
import styles from './week.module.scss';
const Week = ({ isFirst, week, month, year, fromDate, toDate, hoverDate, onSelectDate, onHoverDate, minDate, maxDate, highlightToday, disabledDays = [], disabledDates = [], endSeasonDisabledDates = [], leadingPrices, availableDates, isLeadingPricesEnabled, isInventoryDrivenCalendarEnabled, showRelativePricing = false, }) => {
    const generateDay = () => {
        return [...Array.from(Array(week.days).keys())].map((index) => {
            const dateIndex = index + week.start;
            const dateValue = new Date(year, month, dateIndex);
            const leadingPrice = leadingPrices === null || leadingPrices === void 0 ? void 0 : leadingPrices.find((leadingPrice) => isSameDay(dateValue, parse(leadingPrice.date, 'dd/MM/yyyy', new Date())));
            const dayName = getDay(dateValue);
            const availableDatesFilteredByCurrentDate = (availableDates === null || availableDates === void 0 ? void 0 : availableDates.filter(({ date }) => date === format(dateValue, 'dd/MM/yyyy'))) || [];
            const disabled = (minDate && isBefore(dateValue, minDate)) ||
                (maxDate && isAfter(dateValue, maxDate)) ||
                (!isInventoryDrivenCalendarEnabled && disabledDays.includes(dayName)) ||
                (!isInventoryDrivenCalendarEnabled &&
                    !!disabledDates.find((date) => isSameDay(date, dateValue))) ||
                (isInventoryDrivenCalendarEnabled && !(availableDatesFilteredByCurrentDate === null || availableDatesFilteredByCurrentDate === void 0 ? void 0 : availableDatesFilteredByCurrentDate.length)) ||
                (isLeadingPricesEnabled && !leadingPrice);
            const disabledEndOfSeason = !!endSeasonDisabledDates.find((date) => isSameDay(date, dateValue));
            const soldOut = Array.isArray(leadingPrices) && !leadingPrice && !disabled;
            const selected = (fromDate && isSameDay(fromDate, dateValue)) ||
                (toDate && isSameDay(toDate, dateValue)) ||
                false;
            const highlight = highlightToday && isSameDay(dateValue, new Date()) && !selected;
            let hovered = false;
            if (fromDate && !isSameDay(fromDate, toDate)) {
                if (toDate && isAfter(dateValue, fromDate) && isBefore(dateValue, toDate)) {
                    hovered = true;
                }
                if (!toDate &&
                    hoverDate &&
                    isAfter(dateValue, fromDate) &&
                    isBefore(dateValue, hoverDate)) {
                    hovered = true;
                }
            }
            let isEndDate = false;
            if ((toDate && fromDate && isSameDay(dateValue, toDate)) ||
                (!toDate && hoverDate && isSameDay(dateValue, hoverDate))) {
                isEndDate = true;
            }
            let isStartDate = false;
            if ((toDate && fromDate && isSameDay(dateValue, fromDate)) ||
                (!fromDate && hoverDate && isSameDay(dateValue, hoverDate))) {
                isStartDate = true;
            }
            return (<Day key={index} dateIndex={dateIndex} dateValue={dateValue} onSelectDate={onSelectDate} onHoverDate={onHoverDate} selected={selected} hovered={hovered} highlight={highlight} disabled={!!disabled} disabledEndOfSeason={disabledEndOfSeason} isEndDay={isEndDate} isStartDay={isStartDate} leadingPrice={leadingPrice} soldOut={soldOut} isLeadingPricesEnabled={isLeadingPricesEnabled} showRelativePricing={showRelativePricing}/>);
        });
    };
    return <div className={cx(styles.week, isFirst && styles.firstWeek)}>{generateDay()}</div>;
};
export default Week;
